import { KEYS } from "../Keys";

/* Event announcements */

export const GetEventAnnoucements = async (values, page) => {
  const url = `/event/geteventannouncements?page=${page}&limit=10`;
  const response = await fetch(KEYS.API + url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${localStorage.getItem("userToken")}`
    },
    body: JSON.stringify(values)
  });
  return response;
};

export const CreateEventAnnoucements = async (values) => {
  const response = await fetch(KEYS.API + "/event/createeventannouncements", {
    method: "POST",
    headers: {
      authorization: `Bearer ${localStorage.getItem("userToken")}`
    },
    body: values
  });
  return response;
};
